import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const FullScreenCircularProgress = ({ size }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
  >
    <CircularProgress size={size} />
  </Box>
);

export default FullScreenCircularProgress;
